const U = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove", "dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
const D = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
const C = ["", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];

function upTo999(n) {
  if (n === 0) return "";
  if (n === 100) return "cem";
  const c = Math.floor(n / 100), r = n % 100, parts = [];
  if (c) parts.push(C[c]);
  if (r < 20) { if (r) parts.push(U[r]); }
  else { parts.push(D[Math.floor(r / 10)] + (r % 10 ? ` e ${U[r % 10]}` : "")); }
  return parts.join(" e ");
}

function intWords(n) {
  if (n === 0) return "zero";
  const groups = [[1e9, "bilhão", "bilhões"], [1e6, "milhão", "milhões"], [1e3, "mil", "mil"]];
  const parts = [];
  let rest = n;
  for (const [v, s, p] of groups) {
    const q = Math.floor(rest / v);
    if (q) { parts.push(v === 1e3 && q === 1 ? "mil" : `${upTo999(q)} ${q === 1 ? s : p}`); rest %= v; }
  }
  if (rest) parts.push(upTo999(rest));
  if (parts.length > 1 && (rest < 100 || rest % 100 === 0) && rest) parts.splice(parts.length - 1, 0, "e");
  return parts.join(" ").replace(/ e e /g, " e ");
}

export function valorPorExtenso(valor) {
  const v = Math.round((Number(valor) || 0) * 100);
  const reais = Math.floor(v / 100), cents = v % 100;
  const out = [];
  if (reais) out.push(`${intWords(reais)}${reais >= 1e6 && reais % 1e6 === 0 ? " de" : ""} ${reais === 1 ? "real" : "reais"}`);
  if (cents) out.push(`${intWords(cents)} ${cents === 1 ? "centavo" : "centavos"}`);
  return out.length ? out.join(" e ") : "zero real";
}
